import { createStore } from "vuex";
import bootstrap from "bootstrap/dist/js/bootstrap.min.js";
import { nextTick } from "vue";

// Helper function to safely parse sessionStorage data
const getSessionData = (key) => {
  try {
    return JSON.parse(sessionStorage.getItem(key));
  } catch {
    return null;
  }
};

export default createStore({
  state: {
    hideConfigButton: false,
    isPinned: true,
    showConfig: false,
    isRTL: false,
    color: "",
    sidebarType: "bg-dark",
    darkMode: true,
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showFooter: true,
    showMain: true,
    layout: "default",
    bootstrap,
    isMinimized: false,
    // Add user-related state
    userData: getSessionData('userData') || {},
    token: sessionStorage.getItem("token") || null,
    isAuthenticated: !!sessionStorage.getItem("token")
  },
  mutations: {
    setConfigButtonVisibility(state, visibility) {
      state.hideConfigButton = visibility;
    },
  
    toggleConfigurator(state) {
      state.showConfig = !state.showConfig;
    },
    
    navbarMinimize(state) {
      state.isMinimized = !state.isMinimized;
      
      // Use $nextTick to ensure DOM updates
      nextTick(() => {
        const sidenav = document.querySelector(".g-sidenav-show");
        if (sidenav) {
          if (state.isMinimized) {
            sidenav.classList.add("g-sidenav-hidden");
            sidenav.classList.remove("g-sidenav-pinned");
          } else {
            sidenav.classList.remove("g-sidenav-hidden");
            sidenav.classList.add("g-sidenav-pinned");
          }
        }
      });
    },
    
    setSidebarType(state, payload) {
      state.sidebarType = payload;
    },
    
    navbarFixed(state) {
      state.isNavFixed = !state.isNavFixed;
    },
    
    toggleDefaultLayout(state) {
      state.showNavbar = !state.showNavbar;
      state.showSidenav = !state.showSidenav;
      state.showFooter = !state.showFooter;
    },
    
    onlyShowNavBar(state) {
      state.showSidenav = !state.showSidenav;
      state.showFooter = !state.showFooter;
    },
    
    // New mutations for user management
    setUserData(state, payload) {
      state.userData = payload;
      state.isAuthenticated = !!payload;
      sessionStorage.setItem('userData', JSON.stringify(payload));
    },
    
    setToken(state, token) {
      state.token = token;
      state.isAuthenticated = !!token;
      if (token) {
        sessionStorage.setItem("token", token);
      } else {
        sessionStorage.removeItem("token");
      }
    },
    
    clearAuth(state) {
      state.userData = {};
      state.token = null;
      state.isAuthenticated = false;
      sessionStorage.removeItem('userData');
      sessionStorage.removeItem('token');
    },

    setShowSidenav(state, value) {
      state.showSidenav = value;
    } 
  },
  actions: {
    toggleSidebarColor({ commit }, payload) {
      commit("setSidebarType", payload);
    },
    
    setConfigButtonVisibility({ commit }, visibility) {
      commit("setConfigButtonVisibility", visibility);
    },
    
    // New actions for user management
    login({ commit }, { userData, token }) {
      commit('setUserData', userData);
      commit('setToken', token);
    },
    
    updateUserData({ commit }, userData) {
      commit('setUserData', userData);
    },
    
    logout({ commit }) {
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("userData");
      sessionStorage.removeItem("userRole");
      
      // Clear Vuex state
      commit('clearAuth');
    },
  },
  getters: {
    // New getters for user data
    currentUser: (state) => state.userData,
    isAuthenticated: (state) => state.isAuthenticated,
    userRole: (state) => state.userData?.roleId || null
  }
});